import React from 'react'

// icons
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// router
import { withRouter } from 'react-router-dom'
import useDelete from './hooks/useDelete'

const ItemArticulo = ({ articulo, history, setIsLoad }) => {
    const { deleteArticuloSubmit } = useDelete(setIsLoad)

    return (
        <tr>
            <th scope="row">{articulo.codigo}</th>
            <td>{articulo.nombre}</td>
            <td>{articulo.pesable ? 'SI' : 'NO'}</td>
            <td>{articulo.balanza ? 'SI' : 'NO'}</td>
            <td>{articulo.compuesto ? 'SI' : 'NO'}</td>
            <td>${articulo.costo.toFixed(2)}</td>
            <td>${articulo.precioFinal.toFixed(2)}</td>
            <td>{articulo.porcentajeGanancia}%</td>
            <td>{articulo.familia.nombre}</td>
            <td>{articulo.marca.nombre}</td>
            <td>{articulo.unidadMedida.nombre}</td>
            <td>
                <button
                    className="btn text-danger"
                    onClick={() => {
                        const editPath = articulo.compuesto
                            ? `edit-articulo-compuesto/${articulo.id}`
                            : `edit-articulo/${articulo.id}`
                        history.push(editPath, {
                            articulo: articulo,
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                    className="btn text-primary"
                    onClick={() => {
                        deleteArticuloSubmit(articulo)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemArticulo)
